import Logo3 from '../assets/images/logo3.png';
import Logo4 from '../assets/images/logo4.png';
import Logo5 from '../assets/images/logo5.png';
import Logo6 from '../assets/images/logo6.png';
import Logo7 from '../assets/images/logo7.png';
import Logo8 from '../assets/images/logo8.png';
import Logo9 from '../assets/images/logo9.png';
import Logo10 from '../assets/images/logo10.png';
import Logo11 from '../assets/images/logo11.png';
import Logo12 from '../assets/images/logo12.png';
import Logo13 from '../assets/images/logo13.png';
import Logo14 from '../assets/images/logo14.png';
import Logo15 from '../assets/images/logo15.png';
import Logo16 from '../assets/images/logo16.png';
import Logo17 from '../assets/images/logo17.png';
import Logo18 from '../assets/images/logo18.png';
import Logo19 from '../assets/images/logo19.png';

export default [
  {
    logo: Logo3, alt: 'Wings', w: 'w-[91px]', h: 'h-[76px]'
  },
  {
    logo: Logo4, alt: 'Wings', w: 'w-[255px]', h: 'h-[30px]'
  },
  {
    logo: Logo5, alt: 'Wings', w: 'w-[84px]', h: 'h-[84px]'
  },
  {
    logo: Logo6, alt: 'Wings', w: 'w-[154px]', h: 'h-[56px]'
  },
  {
    logo: Logo7, alt: 'Wings', w: 'w-[246px]', h: 'h-[68px]'
  },
  {
    logo: Logo8, alt: 'Wings', w: 'w-[185px]', h: 'h-[70px]'
  },
  {
    logo: Logo9, alt: 'Wings', w: 'w-[148px]', h: 'h-[66px]'
  },
  {
    logo: Logo10, alt: 'Wings', w: 'w-[96px]', h: 'h-[96px]'
  },
  {
    logo: Logo11, alt: 'Wings', w: 'w-[101px]', h: 'h-[84px]'
  },
  {
    logo: Logo12, alt: 'Wings', w: 'w-[180px]', h: 'h-[66px]'
  },
  {
    logo: Logo13, alt: 'Wings', w: 'w-[155px]', h: 'h-[88px]'
  },
  {
    logo: Logo14, alt: 'Wings', w: 'w-[226px]', h: 'h-[60px]'
  },
  {
    logo: Logo15, alt: 'Wings', w: 'w-[161px]', h: 'h-[66px]'
  },
  {
    logo: Logo16, alt: 'Wings', w: 'w-[268px]', h: 'h-[70px]'
  },
  {
    logo: Logo17, alt: 'Wings', w: 'w-[201px]', h: 'h-[102px]'
  },
  {
    logo: Logo18, alt: 'Wings', w: 'w-[238px]', h: 'h-[40px]'
  },
  {
    logo: Logo19, alt: 'Wings', w: 'w-[126px]', h: 'h-[52px]'
  }
];
